import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import PrimaryButton from '../button/PrimaryButton';
import SecondaryButton from '../button/SecondaryButton';

interface DefaultDialogProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	text: string;
}

const DefaultDialog: React.FC<DefaultDialogProps> = ({
	open,
	onClose,
	onConfirm,
	text,
}) => {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="xs">
			<DialogContent>
				<DialogContentText className="!mt-4 !font-inter !text-[000] !text-[14px] !text-primary-grey">
					{text}
				</DialogContentText>
			</DialogContent>
			<DialogActions
				style={{ justifyContent: 'center', marginBottom: '15px' }}
			>
				<PrimaryButton
					addStyle="!w-[62px] !h-[36px]"
					onClick={onConfirm}
				>
					Yes
				</PrimaryButton>
				<SecondaryButton
					onClick={onClose}
					addStyle="!w-[62px] !h-[36px]"
				>
					No
				</SecondaryButton>
			</DialogActions>
		</Dialog>
	);
};

export default DefaultDialog;
